<style lang="scss" src='./ProvisioningStep0.scss' scoped ></style>
<template src="./ProvisioningStep0.html"></template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import CommonComponent from '@/components/utils/CommonComponent.vue';

export default {
  name: 'ProvisioningStep0',
  extends: CommonComponent,
  data() {
    return ({
      sensor: null,
      rssiIcon: null,
    });
  },
  computed: {
    ...mapState(['course']), 

    isCourseType(){
      if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
      || !this.course.facility_type){
        return true;
      }else{
        return false;
      }
    },

  },

  methods: {
    async getRssiIcon() {
      this.rssiIcon = await this.GetRssiIcon(this.sensor);
    },
    ...mapMutations('SensorProvisioning', ['setStep']),
    ...mapActions('SensorList', ['GetRssiIcon']),

    getSuggestedDepth() {
      if(this.course && this.course.measurement_system && this.course.measurement_system == 'METRIC'){
        return '5 cm';
      }
      return '2\"';
    },
  },

  beforeCreate() {},

  created() {},

  mounted() {
    this.sensor = this.$store.state.sensor;
    this.getRssiIcon();
  },
};
</script>
